export default {
  colors: {
    background: '#173867',
    primary: '#4C6A93',
    secondary: '#E09C26',
    error: '#DB0617',
  },
}
